import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { errMsg } from "@/lib/api";
import { portalApi } from "@/lib/portalApi";
import { PortalAuthCard } from "./PortalLogin";

export default function PortalVerifyEmail() {
  const [params] = useSearchParams();
  const [res, setRes] = useState(null);
  const [error, setError] = useState("");
  const done = useRef(false);
  useEffect(() => {
    if (done.current) { return; }
    done.current = true;
    portalApi.post("/auth/verify-email", { token: params.get("token") || "" }).then((r) => setRes(r.data)).catch((e) => setError(errMsg(e)));
  }, [params]);
  return (
    <PortalAuthCard title="Confirm your new email" subtitle={res ? `${res.tenant.name} client portal` : "Client portal"} brand={res?.tenant.brand_color}>
      {res ? <div className="space-y-3" data-testid="verify-email-success"><p className="text-sm text-slate-700">Your login email is now <b data-testid="verify-email-new">{res.email}</b>. Use it the next time you sign in.</p>
        <Link to="/portal" className="text-sm font-medium text-[#13294B] underline" data-testid="verify-email-continue">Go to the portal</Link></div>
        : error ? <p className="text-sm text-rose-700" data-testid="verify-email-error">{error}</p>
          : <p className="text-sm text-slate-500" data-testid="verify-email-loading">Confirming your new email…</p>}
    </PortalAuthCard>
  );
}
